import { actsApi } from '../api/acts'

export const {
  useGetActsQuery,
  useLazyGetActsQuery,
  useCreateActMutation,
  useUpdateActMutation,
  useDeleteActMutation,
} = actsApi
